// assets/cib-sweet-hearts-widget-lock.js

(function () {
  function initLock() {
    // Contenedor principal del producto
    const productEl = document.querySelector('.cc-main-product .product.js-product');
    if (!productEl) return;

    // Form principal de producto
    const form = productEl.querySelector('form.js-product-form-main, form.js-product-form');
    if (!form) return;

    // Botón "Add to cart"
    const addBtn = form.querySelector('.product-info__add-button button[name="add"]');
    if (!addBtn) return;

    const widgetSelector = '.tpo_option-set-wrapper'; // wrapper del widget
    let widgetReady = false;

    function markReadyIfWidgetExists() {
      if (productEl.querySelector(widgetSelector)) {
        widgetReady = true;
        addBtn.disabled = false;
        addBtn.classList.remove('is-widget-wait');
        return true;
      }
      return false;
    }

    // 1) Estado inicial: asumimos que el widget NO ha cargado
    addBtn.disabled = true;
    addBtn.classList.add('is-widget-wait');

    // 2) Bloquear SUBMIT del formulario hasta que el widget esté listo
    form.addEventListener(
      'submit',
      function (e) {
        if (!widgetReady) {
          // 👉 Nada de enviar request a Shopify todavía
          e.preventDefault();
          if (typeof e.stopImmediatePropagation === 'function') {
            e.stopImmediatePropagation();
          }
          e.stopPropagation();
          // Opcional: mostrar mensaje
          // alert('Please wait until the options widget finishes loading.');
          return false;
        }
        // Si widgetReady === true, dejamos que el tema haga su flujo normal
      },
      true // capture: este handler corre antes que product-form.js
    );

    // 3) Si el widget YA está en el DOM cuando corre el script, liberamos
    if (markReadyIfWidgetExists()) return;

    // 4) Observar el DOM hasta que el widget se inyecte
    const observer = new MutationObserver(function () {
      if (markReadyIfWidgetExists()) {
        observer.disconnect();
      }
    });

    observer.observe(productEl, { childList: true, subtree: true });

    // 5) Failsafe: si nunca aparece el widget, re-habilitar después de X segundos
    setTimeout(function () {
      if (!widgetReady) {
        widgetReady = true;
        addBtn.disabled = false;
        addBtn.classList.remove('is-widget-wait');
        observer.disconnect();
      }
    }, 10000); // 10s (ajustable)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLock);
  } else {
    initLock();
  }
})();
